<template>

  <div class="row">
    <div v-for="(position, index) in positions" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 position-card" @click="$emit('position-selected', index)">
      <div class="card interactive" style="width: 100%">
        <div class="card-header text-white bg-dark">
          <h5 class="card-title">{{ position.name }}</h5>
        </div>
        <div class="text-center">
          <div class="thumb-image">
            <img :src="position.img" class="card-img-top" :alt="position.name">
          </div>
        </div>
        <div v-if="position.classification != null" class="card-footer text-center">
          <span>{{ position.classification }}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
      name: "app-positions-thumbnail",
      props: {
        positions: { type: Array, requite: true }
      }
    }
</script>

<style scoped>
 .position-card {
   margin-bottom: 10px;
 }

 .thumb-image {
   width: 200px;
   height: 200px;
   margin: auto;
 }

 .thumb-image img {
   width: 100%;
   height: 100%;
   overflow: hidden;
 }

 .interactive {
   cursor: pointer;
 }
</style>



// WEBPACK FOOTER //
// src/components/app-positions-thumbnail.vue